"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noticeError = void 0;

/**
 * @File         : 通知错误
 * @Author       : gaojiajun01
 * @Date         : 2022-08-09 19:24:23
 * @LastEditors  : gaojiajun01
 * @LastEditTime : 2022-08-09 19:29:09
*/
var noticeError = function noticeError(err) {
  if (process.env.NODE_ENV === 'development') {
    alert(err);
  }

  throw new Error(err);
};

exports.noticeError = noticeError;